import { render, staticRenderFns } from "./quick3.vue?vue&type=template&id=194de64a&"
import script from "./quick3.vue?vue&type=script&lang=js&"
export * from "./quick3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports